import React, { useState,useEffect,useContext  } from "react";
import { Link } from 'react-router-dom';
//import { messaging } from "./firebase/initFirebase"
import Lang from './lang/translations';
import Auth from '../userServices/authServices';


import Context from './context/context';

const config = require("./_helpers/configServizi"); 

export default function NavbarDesktop() {
	 
	const  context = useContext(Context)
  const [coloreMessaggio, setColoreMessaggio] = useState("");


 

  const domain = window.location.hostname;
  
  const url_logo = config.servizi[domain].logo_navbar_desktop;
  
  
  function attivaPush(){
   /* if(messaging){
      messaging.getToken().then((currentToken) => {
        if (currentToken) {
          helpers.updatePushToken(currentToken)
        } else {
          // Show permission request.
          console.log('No registration token available. Request permission to generate one.');
          // Show permission UI.
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
    }*/
  }


  useEffect(() => { 
		
		
    if((context.creditiMessaggi / 2)*100 > 67){ setColoreMessaggio("color_full");}
    if((context.creditiMessaggi / 2)*100 >34 && context.creditiMessaggi < 66.9 ){ setColoreMessaggio("color_medium");}
    if((context.creditiMessaggi / 2)*100 < 34){setColoreMessaggio("color_empty");}

 },[context.creditiMessaggi]);
  

  
	 
  return (<nav className="navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-block searchFilters" >
  <div className="navbar-desktop">
    <Link className="navbar-brand" to={context.flusso.messaggi_inviti ? "/match" : "/find"}><img alt="" src={url_logo} className="img-fluid" /></Link>
    <div className="navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mr-auto">
        {context.user_info.cerco != "uomo" ? (
          <li className="nav-item pr-18p">
          <Link to="/match" className="nav-link ">
          <svg  width="20" viewBox="0 0 296.555 296.555"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="currentColor" d="M295.683,96.043c-2.18-15.85-8.425-30.523-18.061-42.435c-8.948-11.063-20.564-19.295-32.71-23.182 c-8.976-2.867-17.831-4.32-26.328-4.32c-21.176,0-40.368,9.127-54.483,25.805c-15.504-16.939-33.672-25.522-54.064-25.523 c-7.944,0-16.223,1.357-24.607,4.035c-12.154,3.889-23.774,12.121-32.725,23.184c-9.639,11.912-15.886,26.588-18.066,42.439 c-0.45,3.271-0.722,6.58-0.824,9.92c-7.899,2.941-15.325,8.416-21.082,15.586c-6.579,8.191-10.8,18.248-12.207,29.082 c-2.234,17.207,2.685,35.756,14.226,53.643c12.819,19.867,33.815,39.189,62.405,57.432c2.624,1.674,5.616,2.512,8.606,2.512 c2.991,0,5.981-0.838,8.606-2.512c9.059-5.781,17.35-11.67,24.864-17.65c9.379,7.32,19.497,14.564,30.346,21.719 c4.632,3.057,10.021,4.674,15.581,4.674c5.559,0,10.946-1.615,15.582-4.672c43.654-28.793,75.516-59.029,94.699-89.873 C292.169,149.008,299.168,121.393,295.683,96.043z M40.506,120.571c4.269-1.363,8.238-1.981,11.932-1.981 c15.393,0,25.982,10.723,33.325,22.836c5.992-13.27,17.023-23.006,32.295-23.006c4.032,0,8.36,0.68,12.969,2.15 c26.176,8.379,53.592,64.572-45.264,127.648C-13.097,185.143,14.318,128.949,40.506,120.571z"></path> </g> </g></svg> <Lang w={"match"} page={"navbar_desktop"}/>
          </Link>
        </li>
        ) : (<li className="nav-item">
          <Link to="/find" className="nav-link ">
           <i className="fa fa-search" /> <Lang w={"cerca"} page={"navbar_desktop"}/>
         </Link>
       </li>)}
        
        <li className="nav-item">
           <Link to="/chats" className="nav-link ">
            <i className="fa fa-comments" /> <Lang w={"messaggi"} page={"navbar_desktop"}/>
          </Link>
        </li>
	    	<li className="nav-item">
          <Link to="/chats" className="nav-link ">
          {context.messaggiNonLetti}
          </Link>
        </li>

        <li className="nav-item">
           <Link to="/notifications" className="nav-link ">
              <i className="fas fa-bell"></i>  <Lang w={"notifiche"} page={"navbar_desktop"}/>
          </Link>
        </li> 

    		
        {(context.premiumLevel !== 2 && context.fluxId !== "0000") && ( 
	      <li className="nav-item">
          <Link to="/vip_plan/cred" onClick={() => {context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined})}} className="nav-link ">
            <i className="fa fa-award"/>  <Lang w={"vip"} page={"navbar_desktop"}/>
          </Link>
        </li>
        )}
       
       <li className="nav-item">
          <Link to="/profile" className="nav-link ">
			 <i className="fa fa-user" /> <Lang w={"profilo"} page={"navbar_desktop"}/>
          </Link>
        </li>
       
        {context.premiumLevel > 0  && ( 
	      <li className="nav-item">
            <Link to="/vip_plan/cred" className="nav-link ">
             
            <div className={coloreMessaggio}>
            <i className="fas fa-coins mr-2"></i> 
              {context.creditiMessaggi}
            </div>
            </Link>
        </li>
        )}
        
        <a onClick={() => Auth.logout()}><span className="nav-link">
          <i className="fas fa-sign-out-alt"></i>  <Lang w={"logout"} page={"navbar_desktop"}/>
        </span></a>

      </ul>
      
    </div>
  </div>
  
    </nav>)
}



